import { Skeleton } from '@/components/ui';

/**
 * Loading placeholder for the home "Short Markets" widget — mirrors the
 * {@link SnakeLobbyFeed} two-card stack (header card with title + currency
 * tabs + countdown notch, then the {@link SnakeLobbyCard} preview: asset row,
 * 200px chart, Up/Down chips) so the lobby doesn't jump when it resolves.
 */
export function SnakeLobbyFeedSkeleton() {
  return (
    <div className="w-full">
      {/* Header card — title, currency tabs, countdown notch. */}
      <div className="relative w-full overflow-hidden rounded-t-[12px] border-[1.5px] border-stroke-soft bg-surface py-4 pl-5 pr-4">
        <div className="flex flex-col gap-4">
          <Skeleton className="h-[23px] w-36 rounded" />
          <div className="flex items-center gap-2">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-[28px] w-[92px] rounded-pill" />
            ))}
          </div>
        </div>
        <Skeleton className="absolute right-0 top-4 h-[30px] w-[96px] rounded-l-pill rounded-r-none" />
      </div>

      {/* Preview card — asset row, chart, Up/Down chips. */}
      <div className="flex w-full flex-col gap-4 rounded-b-[12px] border-[1.5px] border-t-0 border-stroke-soft bg-surface px-5 py-4">
        <div className="flex items-center gap-2">
          <Skeleton className="size-[30px] shrink-0 rounded-full" />
          <Skeleton className="h-[23px] w-44 rounded" />
        </div>
        <Skeleton className="h-[200px] w-full rounded-[12px]" />
        <div className="flex gap-2 px-1">
          <Skeleton className="h-10 flex-1 rounded-pill" />
          <Skeleton className="h-10 flex-1 rounded-pill" />
        </div>
      </div>
    </div>
  );
}
